import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ROUTER_ESTIMATE, ROUTER_ESTIMATE_HISTORY } from 'app/AppRouter';
import { EstimateBase } from './EstimateBase';
import { HistoryPage } from './HistoryPage';

export const EstimateRouter = () => {
  return (
    <Switch>
      <Route exact path={ROUTER_ESTIMATE_HISTORY} render={() => <HistoryPage />} />
      <Route exact path={ROUTER_ESTIMATE} render={() => <EstimateBase />} />
    </Switch>
  );
};
